import { Flex, Text, Button, Box, Paragraph } from "theme-ui";
import { ChevronRight } from "react-feather";
import { motion } from "framer-motion";

import { AccordionProps } from "./Accordion.d";

export const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  isOpen,
  onAccordionClick,
  ...rest
}) => {
  return (
    <Box
      sx={{
        boxShadow: 2,
        borderRadius: 2,
        py: 3,
        pl: 4,
        pr: 3,
        backgroundColor: "white",
      }}
      {...rest}
    >
      <Flex
        onClick={() => onAccordionClick?.(!isOpen)}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          flex: 1,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <Text
          sx={{
            fontSize: ["13px", 2, 3],
            fontFamily: "heading",
            pr: [3, 4, 8],
            mb: 1,
          }}
        >
          {title}
        </Text>
        <Button variant="icon" p="3px">
          <motion.div animate={{ rotate: isOpen ? -270 : 0 }}>
            <ChevronRight />
          </motion.div>
        </Button>
      </Flex>
      <motion.div
        animate={{
          height: isOpen ? "auto" : 0,
          opacity: isOpen ? 1 : 0,
          overflow: "hidden",
        }}
      >
        <Box sx={{ py: 1, pr: [3, 4, 6] }}>
          <Paragraph sx={{ fontSize: ["13px", 1, 2], whiteSpace: "pre-wrap" }}>
            {content}
          </Paragraph>
        </Box>
      </motion.div>
    </Box>
  );
};
